// prefer default export if available
const preferDefault = m => (m && m.default) || m

exports.components = {
  "component---src-pages-entreprise-js": () => import("./../../../src/pages/entreprise.js" /* webpackChunkName: "component---src-pages-entreprise-js" */),
  "component---src-pages-experts-mind-js": () => import("./../../../src/pages/experts-mind.js" /* webpackChunkName: "component---src-pages-experts-mind-js" */),
  "component---src-pages-index-js": () => import("./../../../src/pages/index.js" /* webpackChunkName: "component---src-pages-index-js" */),
  "component---src-pages-premiere-meditation-js": () => import("./../../../src/pages/premiere-meditation.js" /* webpackChunkName: "component---src-pages-premiere-meditation-js" */),
  "component---src-pages-workwise-js": () => import("./../../../src/pages/workwise.js" /* webpackChunkName: "component---src-pages-workwise-js" */)
}

